export default __webpack_public_path__ + "static/media/furniture-bg-7.1a5831a6.png";